import { useEffect, useState, useRef } from 'react';
import { healthPackages } from "../Data/healthPack";
import emailjs from 'emailjs-com';
import { useParams } from 'react-router-dom';

function HealthPackages() {
    const { name } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const formRef = useRef();

    const [formData, setFormData] = useState({
        user_name: '',
        user_phone: '',
        user_position: ''
    });

    const decodedName = name ? decodeURIComponent(name) : '';
    const packageItem = healthPackages.find(pkg => pkg.title === decodedName);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (packageItem) {
            setFormData(prev => ({ ...prev, user_position: packageItem.title }));
        }
    }, [packageItem]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_mtn05ga',    
            'template_s01htbp',   
            formRef.current,
            'egxcYC6EeJdXDm0et'        
        )
        .then(() => {
            setIsSubmitted(true);
            setTimeout(() => {
                setIsSubmitted(false);
                setFormData({
                    user_name: '',
                    user_phone: '',
                    user_position: packageItem ? packageItem.title : ''
                });
                setShowModal(false);
            }, 3000);
        })
        .catch((err) => {
            console.error('EmailJS Error:', err);
            alert('Failed to send booking. Please try again.');
        });
    };

    return (
        <section className="healthpackage-section py-5">
            <div className="container">
                <div className="sec-title mb-4 text-center">
                    <h1>Ashwini Preventive Health Check-Up Packages</h1>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
                    {healthPackages.map((pkg, index) => (
                        <div className="col" key={index}>
                            <div className="card h-100 p-3 shadow-sm package-card-bg">
                                <div className="card-header text-center bg-transparent">
                                    <h5 className="mb-0 fw-bold sec-title">{pkg.title}</h5>
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled small custom-bar" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                        {pkg.services.map((test, idx) => (
                                            <li key={idx}>{test}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="card-footer p-0 d-flex justify-content-between align-items-center bg-transparent">
                                    <a href={`/health-packages/${encodeURIComponent(pkg.title)}`} className="btn btn-sm btn-primary">
                                        View Details
                                    </a>
                                    <button
                                        className="btn btn-sm btn-success"
                                        onClick={() => {
                                            setFormData(prev => ({
                                                ...prev,
                                                user_position: pkg.title
                                            }));
                                            setShowModal(true);
                                        }}
                                    >
                                        Book Now
                                    </button>
                                    <div className="d-flex flex-column">
                                        <s className="text-muted">₹{pkg.oldPrice}</s>
                                        <span className="fw-bold text-danger">₹{pkg.newPrice}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {showModal && (
    <div style={{backgroundColor:"rgba(0,0,0,0.5)"}} className="modal show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Book {formData.user_position || 'Package'}</h5>
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                    {isSubmitted ? (
                        <div className="text-center">
                            <span style={{ fontSize: '2rem' }}>🎉</span>
                            <h4>Booking Successful!</h4>
                        </div>
                    ) : (
                        <form ref={formRef} onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    name="user_name"
                                    placeholder="Your Name"
                                    value={formData.user_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="tel"
                                    name="user_phone"
                                    placeholder="Contact Number"
                                    value={formData.user_phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    name="user_position"
                                    value={formData.user_position}
                                    className="form-control"
                                    readOnly
                                />
                            </div>
                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-success me-2">
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    </div>
)}

        </section>
    );
}

export default HealthPackages;
